import { render, staticRenderFns } from "./deleteDetail.vue?vue&type=template&id=67af830a&scoped=true&"
import script from "./deleteDetail.vue?vue&type=script&lang=js&"
export * from "./deleteDetail.vue?vue&type=script&lang=js&"
import style0 from "./deleteDetail.vue?vue&type=style&index=0&id=67af830a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af830a",
  null
  
)

export default component.exports